export const header = {
  scroll() {
    let header = $('nav'),
        zero = 0;
    $(window).on('scroll',function(){
      let scrollAfter = $(this).scrollTop();

      if(scrollAfter > zero && scrollAfter > header.outerHeight()){
        // console.log('down')
        header.addClass('hide');
      }
      else if(scrollAfter == 0){
        // console.log('top')
        header.removeClass('hide');
      }
      else if(scrollAfter < zero){
        // console.log('up')
        header.removeClass('hide');
      }

      setTimeout(()=>{
        zero = scrollAfter;
      },100)
    });
  },
  hover() {
    let li = $('.nav-unit li');
    let nowAct = $('.nav-unit li.active');
    li.on('mouseenter', function(e) {
      const all = $('.nav-unit li');
      let offsetLeft = $(this).offset().left,
          posX = e.pageX,
          w = $(this).outerWidth();

      if(posX > (offsetLeft + (w/2))) {
        if(!$(this).hasClass('active')) {
          all.removeClass('active rightIn leftIn');
          $(this).addClass('rightIn');
        }
      }
      else{
        if(!$(this).hasClass('active')) {
          all.removeClass('active rightIn leftIn');
          $(this).addClass('leftIn');
        }
      }
    }).on('mouseleave', function() {
      const all = $('.nav-unit li');
      if(!$(this).hasClass('active')) {
        $(this).removeClass('leftIn rightIn');
        nowAct.addClass('active');
      }
      else{
        nowAct.removeClass('leftIn rightIn');
      }
    });
  },
  hoverEf() {
    const li = $('.nav-unit li'),
          first = $('.nav-unit li:nth-child(1)');
    li.on('mouseenter',function(){
      if(!$(this).hasClass('active')){
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
      }
    }).on('mouseleave',function(){
      if(!first.hasClass('active')){
        first.siblings().removeClass('active');
        first.addClass('active');
      }
    });
  },
  all() {
    header.scroll();
    header.hover();
  }
}
